import { render, staticRenderFns } from "./windowInfo.vue?vue&type=template&id=4f4752ab&scoped=true&"
import script from "./windowInfo.vue?vue&type=script&lang=js&"
export * from "./windowInfo.vue?vue&type=script&lang=js&"
import style0 from "./windowInfo.vue?vue&type=style&index=0&id=4f4752ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4752ab",
  null
  
)

export default component.exports